import React, { useEffect } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";

import { ThemeProvider } from "styled-components";
import { ProtectedRoute, UnauthenticatedRoute } from "routes/protected-route";
import { GlobalStyles } from "./styles/global";
import { observer } from "mobx-react";
import { appConfigurationStore } from "common/stores/app-configuration-store";
import { setAppTheme } from "common/actions/app-configuration-actions";

const loading = (
  <div className=" text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(
  () => import("./containers/layouts/layout-manager")
);

// Pages
const Auth = React.lazy(() => import("pages/unauthorized/unauth-main"));

const App = observer(() => {
  const { appTheme } = appConfigurationStore;

  useEffect(() => {
    init();
  }, []);

  const init = () => {
    const settings = JSON.parse(localStorage.getItem("settings") || "{}");
    let themeName = settings?.theme;
    if (!themeName) {
      const isPlayer = JSON.parse(
        localStorage.getItem("login") || "{}"
      )?.player;
      themeName = isPlayer ? "blog_light_theme" : "blackMamba";
    }
    setAppTheme(themeName);
  };

  return (
    <ThemeProvider theme={appTheme}>
      <GlobalStyles />
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Routes>
            <Route
              path="/login/*"
              element={
                <UnauthenticatedRoute>
                  <Auth />
                </UnauthenticatedRoute>
              }
            />
            <Route
              path="/auth/*"
              element={
                <UnauthenticatedRoute>
                  <Auth />
                </UnauthenticatedRoute>
              }
            />
            <Route
              path="/auth/:mode/*"
              element={
                <UnauthenticatedRoute>
                  <Auth />
                </UnauthenticatedRoute>
              }
            />
            <Route
              path="/auth/:mode/:username/*"
              element={
                <UnauthenticatedRoute>
                  <Auth />
                </UnauthenticatedRoute>
              }
            />
            <Route
              path="/register/event/:event_id/*"
              element={
                <UnauthenticatedRoute>
                  <Auth />
                </UnauthenticatedRoute>
              }
            />
            <Route
              path="/confirm/:username/*"
              element={
                <UnauthenticatedRoute>
                  <Auth />
                </UnauthenticatedRoute>
              }
            />
            <Route
              path="/forgot-password/*"
              element={
                <UnauthenticatedRoute>
                  <Auth />
                </UnauthenticatedRoute>
              }
            />

            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <TheLayout />
                </ProtectedRoute>
              }
            />
          </Routes>
        </React.Suspense>
      </HashRouter>
    </ThemeProvider>
  );
});

export default App;
